module.exports = __webpack_public_path__ + "img/edge-security-acceleration.756cce1.svg";